if (!customElements.get('cinoton-hero')) {
  class CinotonHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.counter = this.querySelector('[data-hero-counter]');
      this.playButton = this.querySelector('[data-hero-playpause]');
      this.interval = Number(this.dataset.autoplay || 0);
      this.userPaused = this.interval === 0;
      this.index = 0;
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.playButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updatePlayButton();
        if (this.userPaused) this.stop();
        else this.start();
      });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.indexOf(event.target.closest('[data-hero-slide]'));
        if (index >= 0) this.show(index);
        this.userPaused = true;
        this.updatePlayButton();
        this.stop();
      });
      this.show(0);
      this.updatePlayButton();
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(next) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a').forEach((a) => { a.tabIndex = active ? 0 : -1; });
      });
      if (this.counter) {
        this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
      }
    }
    start() {
      this.stop();
      if (this.userPaused || !this.interval || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }
    stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
    updatePlayButton() {
      if (!this.playButton) return;
      this.playButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      this.playButton.setAttribute('aria-pressed', String(this.userPaused));
      this.playButton.querySelector('span').textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
  }
  customElements.define('cinoton-hero', CinotonHero);
}
